import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy from 'formsy-react';
import _, { isEmpty, isEqual, isInteger, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userContext, logout, allowMessengerCheck } from '../../services/User';
import { setAuthState, setSearchFormVisibilityInHeader, setPageType, setShowSidebar } from '../../store/actions/actions';
import React, { useEffect, useState, useRef, Fragment , useContext} from 'react'
import { Confirm, Divider, Grid, Icon, Segment, Table, Button, Message, Container, Dropdown, Label, Menu, Tab, Popup, Modal } from 'semantic-ui-react';
import { getServiceRequestList, singleBuyerRequestBidsHistory, updateRequest, markRequestAsServiced, isRequestAssignmentEnabled, getManagerUsers, isSubscriptionSearchEnabled, updateBuyer, setPriceConfirmation, resetPriceConfirmation } from 'services/Manager'
import './ServiceRequestListContainerNew.less'
import moment, { duration } from 'moment';
import SearchServiceControl from 'components/SearchServiceControl/SearchServiceControl';
import MobileHeader from 'components/MobileHeader/MobileHeader';
import ServiceForm from 'components/ServiceForm/ServiceForm';
import ServiceFormModal from 'components/ServiceFormModal/ServiceFormModal';
import GeneralError from 'components/GeneralError/GeneralError';
import { scrollTop } from 'helpers/smoothScroll';
import close from '../../assets/images/newui/close.png'
import useWindowSize from '../../hooks/useWindowSize';
import DealDetailsModal from 'components/Deals/DealDetailsModal';
import { getBuyerRequestBids, acceptBid } from 'services/Manager';
import '../DealsContainer/DealsContainer.less'
import ServiceRequestBidHistoryModal from 'components/ServiceRequestBidHistoryModal/ServiceRequestBidHistoryModal'
import ServiceRequestBidHistory from 'components/ServiceRequestBidHistory/ServiceRequestBidHistory'
import ServiceRequestNotesNew from 'components/ServiceRequestNotesNew/ServiceRequestNotesNew';
import ServiceRequestNotesModal from 'components/ServiceRequestNotesModal/ServiceRequestNotesModal';
import DGCheckbox from 'components/FormControls/Checkbox/DGCheckbox';
import { Checkbox } from 'formsy-semantic-ui-react';
import ServiceRequestMapNew from '../../components/ServiceRequestMapNew/ServiceRequestMapNew';

import done from '../../assets/images/newui/done.svg';
import detail_eye from '../../assets/images/newui/newrequestpage/detail-eye-icon.svg';
import edit_pen from '../../assets/images/newui/newrequestpage/edit-pen-icon.svg';
import mark_serviced_icon from '../../assets/images/newui/newrequestpage/mark-serviced-icon.svg';
import confirm_price_icon from '../../assets/images/newui/newrequestpage/confirm-price-icon.svg';

import extend_icon from '../../assets/images/newui/newrequestpage/extend-icon.svg';
import expiry_icon from '../../assets/images/newui/newrequestpage/expiry-icon.svg';
import list_loading from '../../assets/images/newui/newrequestpage/list-loading.svg';

import DisplayDistance from 'components/RequestPostProcessing/DisplayDistance/DisplayDistance';
import ChatContainerNew from '../ChatContainerNew/ChatContainerNew'
import { useParams, useNavigate } from "react-router-dom";

import logo_new from '../../assets/images/newui/newrequestpage/logo-d.svg'
import logo_new_full from '../../assets/images/newui/newrequestpage/logo-full.svg'
import { addValidationRule } from 'formsy-react';
import { formatPhone, unFormatPhone } from '../../helpers/parsePhone';
import PhoneInput, { format, normalize } from "react-phone-input-auto-format";
import { NavigationUrls } from 'constants/NavigationUrls';
import ServiceRequestAssignment from 'components/ServiceRequestAssignment/ServiceRequestAssignment';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import ToggleTextingForSBRContainer from 'components/ToggleTextingForSBRContainer/ToggleTextingForSBRContainer';
import { isNotBlankString, isValidCellNumber, postiveNumber } from 'helpers/validation';
import featuresList from '../../constants/FeaturesList';
import { checkManagerAuthorization } from 'helpers/authorization';
import CallScriptConatiner from '../../components/CallScript/CallScriptContainer';

import {SocketContext} from '../../context/socket';
import { REFRESH_SBR_MUNTAZIM_DASHBOARD } from 'constants/socketIOListener';
import ServiceRequestCallHistory from 'components/ServiceRequestCallHistory/ServiceRequestCallHistory';

const EDIT_MODE_SERVICE_CHANGE = 'service_change';
const EDIT_MODE_EXTEND_EXPIRY = 'expiry_change';
const EDIT_MODE_CHANGE_FORM = 'change_form';
const EDIT_MODE_VIEW_FORM = 'view_form';
const EDIT_MODE_VIEW_NOTES = 'request_notes';
const EDIT_MODE_VIEW_MAP = 'request_map';
const EDIT_MODE_MARK_SERVICED = 'mark_serviced';
const EDIT_MODE_SMS = "sms_view";

const noticationTimeout = 700;

addValidationRule('isNotBlankString', isNotBlankString);
addValidationRule('isValidCellNumber', isValidCellNumber);
addValidationRule('postiveNumber', postiveNumber);

const ExpiredColumn = (props) => {
    const { request } = props;
    if (request.sbr.isAccepted) {
        return <div className={`accepted-tag-new ${request.sbr.servicedAt ? "serviced-tag" : ""}`}>
            {/* <div><img src={done}></img></div> */}
            <div>
                {/* Accepted */}
                {request.sbr.servicedAt ? "Serviced" : "Accepted"
                    //  && <span> & Serviced</span>
                }
            </div>
            {/* <div>Serviced
                </div>    */}
        </div>;
    }
    else {
        if (moment(request.sbr.expiry) < moment()) {
            return <div className="expired-tag-new">

                {/* <div>{moment(request.sbr.expiry).format('MMM DD YYYY hh:mm:ss')}</div> */}
                <div>{moment(request.sbr.expiry).format('MMM DD YYYY')}</div>
            </div>;
        }
        else {
            // return <div className={"not-expired"} >{moment(request.sbr.expiry).format('MMM DD YYYY hh:mm:ss')}</div>;
            return <div className={"not-expired"} >{moment(request.sbr.expiry).format('MMM DD YYYY')}</div>;
        }
    }

}

function ServiceRequestListContainerNew(props) {

    const params = useParams();
    const requestID = params.requestID ? params.requestID : '';
    //setSearchedRequestID(requestID);

    const [searchedRequestID, setSearchedRequestID] = useState(requestID);
    const [serviceRequestList, setServiceRequestList] = useState([]);
    const [currentRequestID, setCurrentRequestID] = useState(0);
    const [currentRequestBuyerID, setCurrentRequestBuyerID] = useState(0);

    const [currentRequestLatLon, setCurrentRequestLatLon] = useState({});
    const [currentRequestDiscount, setCurrentRequestDiscount] = useState({});

    const [currentRequestTimezone, setCurrentRequestTimezone] = useState('America/Chicago');
    const [currentUser, setCurrentUser] = useState(props.currentUser);


    //const { activeMenuItem, currentUser } = props;

    /*const [newServiceIDForCurrentRequest, setNewServiceIDForCurrentRequest] = useState(0);
    const [newServiceNameForCurrentRequest, setNewServiceNameForCurrentRequest] = useState('');*/

    const [newServiceForCurrentRequest, setNewServiceForCurrentRequest] = useState({});

    const [serviceRequestIsAccepted, setServiceRequestIsAccepted] = useState(false);

    const [showConfirm, setShowConfirm] = useState(false);

    /*const [oldServiceName, setOldServiceName] = useState('');
    const [oldServiceID, setOldServiceID] = useState(0);*/

    const [serviceRequestCurrentService, setServiceRequestCurrentService] = useState({});

    const [confirmationMessage, setConfirmationMessage] = useState('');

    const [editMode, setEditMode] = useState('');

    const [showFilterErrorMessage, setShowFilterErrorMessage] = useState(false);
    //const [filterErrorMessage, setFilterErrorMessage] = useState('');

    const [serviceFormData, setServiceFormData] = useState({});

    const [newServiceFormData, setNewServiceFormData] = useState({});

    const [requestUpdateErrorMessage, setRequestUpdateErrorMessage] = useState('');

    const [showDetailsModal, setShowDetailsModal] = useState(false);

    const [showServiceFormModal, setShowServiceFormModal] = useState(false);


    const [bids, setBids] = useState([]);

    const [showBidAcceptanceConfirmationModal, setShowBidAcceptanceConfirmationModal] = useState(false);

    const [selectedBid, setSelectedBid] = useState({});

    const [showBidHistoryModal, setShowBidHistoryModal] = useState(false);

    const [showNotesModal, setShowNotesModal] = useState(false);

    const [selectedServiceRequest, setSelectedServiceRequest] = useState({});

    const [showAllNearByPros, setShowAllNearByPros] = useState(false);

    const [sideBarIsOpen, setSideBarIsOpen] = useState(requestID ? false : true)

    const [isShowBlurBackground, setIsShowBlurBackground] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);

    const [acceptBidError, setAcceptBidError] = useState('');

    const [searchFormState, setSearchFormState] = useState({ requestID: requestID, cellNumber: "" })

    const [keysState, setkeysState] = useState({ ServiceRequestBidHistory: 1, ServiceRequestNotes: 1 })

    const [bidAcceptAttemptIDs, setBidAcceptAttemptIDs] = useState([]);
    const [paymentFailureOverrride, setPaymentFailureOverrride] = useState(false);

    const [expandState, setExpandState] = useState({
        expandBidHistory: false,
        expandNotes: false,
        expandChat: false,
        expandMap: false,
        expandCallHistory: false
    });

    const [serviceNameChangeState, setServiceNameChangeState] = useState(false)
    const [isSnippetsOpen, setIsSnippetsOpen] = useState(false);

    // const [allowMessenger , allowMessengerState] = useState(false);

    // const [subscriptionSearchEnabled , setSubscriptionSearchEnabled] = useState(false);

    const [requestAssignmentEnabled, setRequestAssignmentEnabled] = useState(false);
    const [requestTextingEnabled, setRequestTextingEnabled] = useState(false);
    const [bidPlacementSearchEnabled, setBidPlacementSearchEnabled] = useState(false);
    const [showProsLinkEnabled, setShowProsLinkEnabled] = useState(false);
    const [editRequestEnabled, setEditRequestEnabled] = useState(false);
    const [addRequestNotesEnabled, setAddRequestNotesEnabled] = useState(false);
    const [buyerCallingEnabled, setBuyerCallingEnabled] = useState(false);
    const [callAnyoneEnabled, setCallAnyoneEnabled] = useState(false);


    const [managerUsers, setManagerUsers] = useState([]);

    const [buyerDetailsState, setBuyerDetailsState] = useState({})
    const [isBuyerNumberEditState, setIsBuyerNumberEditState] = useState(false)
    const [buyerNewNumberState, setBuyerNewNumberState] = useState('')
    const [buyerPhoneNoCopyToolTipText, setBuyerPhoneNoCopyToolTipText] = useState('Copy')
    const [buyerNumberEditEnabled, setBuyerNumberEditEnabled] = useState(false);
    const [acceptBidLoading, setAcceptBidLoading] = useState(false);

    const [startBuyerCall, setStartBuyerCall] = useState(false);
    const [startSellerCall, setStarSellerCall] = useState(false);

    const history = useNavigate();
    const formRef = useRef();
    const serviceNameSpanRef = useRef();

    const updateIconRef = useRef();

    const errorMessageRef = useRef();

    const windowSize = useWindowSize();

    const [showConfirmPriceModal, setShowConfirmPriceModal] = useState(false);
    const [confirmationPrice, setConfirmationPrice] = useState(undefined);

    let requestIDFilterInputRef;
    let notifySellers = false;


    const socket = useContext(SocketContext);

    useEffect(() => {
        socket.on(REFRESH_SBR_MUNTAZIM_DASHBOARD, (data) => {
            if (selectedServiceRequest && selectedServiceRequest.sbr &&
                (data.sbrID == selectedServiceRequest.sbr.singleBuyerRequestID)) {
                onValidSubmit();
            }
        });
    } , [socket , selectedServiceRequest])

    useEffect(() => {
        // const res = await isRequestAssignmentEnabled();
        // if (res.resStatus == 200) {
        //     setRequestAssignmentEnabled(res.data.enabled);
        // }

        // let subsEnabledRes = await isSubscriptionSearchEnabled();
        // if (subsEnabledRes.resStatus == 200) {
        //     setSubscriptionSearchEnabled(subsEnabledRes.data.enabled);
        // }

        async function onLoad() {
            const userRes = await getManagerUsers();
            if (userRes.resStatus == 200) {
                setManagerUsers(userRes.data);
            }

            // let allowMessengerRes = await allowMessengerCheck();
            // if (allowMessengerRes.resStatus == 200) {
            //     allowMessengerState(allowMessengerRes.data.allowMessenger)
            // }

            setBuyerNumberEditEnabled(checkManagerAuthorization(featuresList.EDIT_BUYER_NUMBER, currentUser))
            setRequestAssignmentEnabled(checkManagerAuthorization(featuresList.REQUEST_ASSIGNMENT, currentUser));
            setRequestTextingEnabled(checkManagerAuthorization(featuresList.REQUEST_TEXTING, currentUser));
            setBidPlacementSearchEnabled(checkManagerAuthorization(featuresList.BID_PLACEMENT_SEARCH, currentUser));
            setShowProsLinkEnabled(checkManagerAuthorization(featuresList.SHOW_PROS_LINK, currentUser))
            setEditRequestEnabled(checkManagerAuthorization(featuresList.EDIT_REQUEST, currentUser))
            setAddRequestNotesEnabled(checkManagerAuthorization(featuresList.ADD_REQUEST_NOTES, currentUser))
            setBuyerCallingEnabled(checkManagerAuthorization(featuresList.CALL_BUYER, currentUser))
            setCallAnyoneEnabled(checkManagerAuthorization(featuresList.CALL_ANYONE, currentUser))
            
        }
        onLoad();

        
        
    }, []);

    useEffect(() => {
        if (selectedServiceRequest.buyer) {
            //formRef.current.submit();
            console.log('buyer detail set', selectedServiceRequest.buyer)
            setBuyerDetailsState(selectedServiceRequest.buyer)
            setBuyerNewNumberState(format(selectedServiceRequest.buyer.buyerCellPhone))
        }

    }, [selectedServiceRequest]);


    // const allowMessengerCheckHandle = async () => {
    //     let res = await allowMessengerCheck(currentUser.userID);
    //     if (res.resStatus == 200) {
    //         allowMessengerState(res.data.allowMessenger)
    //     }
    // }

    // useEffect(async () => {

    //     if (currentUser) {
    //         await allowMessengerCheckHandle();
    //     }
    // }, [currentUser]);


    useEffect(() => {
        if (searchedRequestID > 0) {
            //formRef.current.submit();
            submitFormOnLoad(searchedRequestID);
        }

    }, [searchedRequestID]);


    useEffect(() => {

        if (newServiceForCurrentRequest || !_.isEmpty(newServiceForCurrentRequest)) {
            if (updateIconRef.current)
                updateIconRef.current.focus();
        }

    }, [newServiceForCurrentRequest]);

    useEffect(() => {

        if (confirmationMessage.length > 0)
            setShowConfirm(true);
        else
            setShowConfirm(false);
        return () => {

        }
    }, [confirmationMessage]);

    useEffect(() => {

        setRequestUpdateErrorMessage('');
        return () => {

        }
    }, [serviceRequestList, serviceFormData, serviceRequestCurrentService]);

    useEffect(() => {

        if (requestUpdateErrorMessage.length > 0) {

            if (errorMessageRef && errorMessageRef.current) {

                errorMessageRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
        return () => {

        }
    }, [requestUpdateErrorMessage]);


    /*useEffect(() => {

        if (filterErrorMessage.length > 0)
            setShowFilterErrorMessage(true);
        else
            setShowFilterErrorMessage(false);
        return () => {

        }
    }, [filterErrorMessage]);*/

    useEffect(() => {
        if (currentRequestID && currentRequestID > 0 && currentRequestBuyerID && currentRequestBuyerID > 0
            //&& editMode == EDIT_MODE_VIEW_FORM 
            && showDetailsModal) {
            getBuyerRequestBids(currentRequestID).then((bidsResponse) => {
                if (bidsResponse.resStatus == 200) {
                    const bids = bidsResponse.data;
                    setBids(bids);
                }
            });

        }
        return () => {

        }
    }, [currentRequestID, currentRequestBuyerID, editMode, showDetailsModal])


    const onValidSubmit = async (values, resetForm, invalidateForm) => {
        try {
            setSelectedServiceRequest({});
            setEditMode('');
            if (values && ((!values.cellNumber || values.cellNumber.length == 0) && (!values.requestID || values.requestID.length == 0))) {
                setShowFilterErrorMessage(true);
                invalidateForm({ requestID: '', cellNumber: '' });
                return;
            }
            else {
                setShowFilterErrorMessage(false);
            }

            //if (formRef && formRef.current) {
            //const searchFilter = formRef.current.getModel();
            //console.log('searchFilter');
            //console.log(searchFilter);
            const serviceRequest = await getServiceRequestList(searchFormState);
            if (serviceRequest.resStatus == 200) {
                setServiceRequestList(serviceRequest.data);
                if (searchFormState.requestID) {
                    history(`/request/${searchFormState.requestID}`)
                    // history.push(`/request/${searchFormState.requestID}`)
                    if (serviceRequest.data.length) {
                        setSideBarIsOpen(false);
                        setSelectedServiceRequest(serviceRequest.data[0])
                    }
                } else if (searchFormState.cellNumber) {
                    if (!selectedServiceRequest && serviceRequest.data.length) {
                        setSelectedServiceRequest(serviceRequest.data[0])
                    } else if (selectedServiceRequest.sbr) {
                        let itemFound = serviceRequest.data.find((item) => item.sbr.singleBuyerRequestID == selectedServiceRequest.sbr.singleBuyerRequestID);
                        if (itemFound) {
                            setSelectedServiceRequest(serviceRequest.data.find((item) => item.sbr.singleBuyerRequestID == selectedServiceRequest.sbr.singleBuyerRequestID))
                        }
                    }
                }

                // if (serviceRequest.data.length) {

                // }

            }
            //}
        } catch (e) {
            console.log(e);
            setSelectedServiceRequest({});
        }
    }

    const submitFormOnLoad = async (requestID) => {
        const serviceRequest = await getServiceRequestList({ requestID: requestID, cellNumber: undefined });
        if (serviceRequest.resStatus == 200) {
            if (requestID > 0) {
                // history.push(`/request/${requestID}`)
                history(`/request/${requestID}`)
                
            }

            setServiceRequestList(serviceRequest.data);
            if (serviceRequest.data.length) {
                setSideBarIsOpen(false);
                setSelectedServiceRequest(serviceRequest.data[0])
            } else {
                setSideBarIsOpen(true);
            }
        }
    }
    /*const handleChange = (e, data) => {
        //console.log(data.value);
        setServiceRequestId(data.value);

    }*/

    const onEditServiceClick = (e, serviceRequestID, requestCurrentService, serviceRequestLat, serviceRequestLon) => {
        setCurrentRequestID(serviceRequestID);
        setCurrentRequestLatLon({ lat: serviceRequestLat, lon: serviceRequestLon });

        setServiceRequestCurrentService(requestCurrentService);
        //setOldServiceName(oldServiceName);
        //setEditMode(EDIT_MODE_SERVICE_CHANGE);
        // serviceNameChangeState
        setServiceNameChangeState(true);
    }

    const onServiceEditCancel = () => {
        resetState();
    }

    const resetState = () => {
        setShowConfirm(false);
        setCurrentRequestID(0);

        setCurrentRequestLatLon({});
        setNewServiceForCurrentRequest({});
        setServiceRequestCurrentService({});

        setEditMode('');
        setConfirmationMessage('');
        setServiceFormData({});
        setNewServiceFormData({});
        setRequestUpdateErrorMessage('');
        setCurrentRequestBuyerID(0);
        setBids([]);
        setShowBidAcceptanceConfirmationModal(false);
        setSelectedBid({});
        setCurrentRequestDiscount({});

        setShowDetailsModal(false);
        setShowServiceFormModal(false);
        setServiceRequestIsAccepted(false);
        notifySellers = false;
        setCurrentRequestTimezone('America/Chicago');

        setServiceNameChangeState(false);
    }

    const setSelectedService = (service) => {

        //setNewServiceIDForCurrentRequest(serviceID);
        //setNewServiceNameForCurrentRequest(serviceName);

        setNewServiceForCurrentRequest(service);
    }

    const onChangeServiceClick = () => {
        const confirmationMessage = `Do you really want to replace "${serviceRequestCurrentService.name}" with "${newServiceForCurrentRequest.title}"?`;
        setConfirmationMessage(confirmationMessage);
    }

    const onExtendExpiryClick = (e, serviceRequestID, requestCurrentService) => {
        setRequestUpdateErrorMessage('');
        setCurrentRequestID(serviceRequestID);
        setEditMode(EDIT_MODE_EXTEND_EXPIRY);
        const confirmationMessage = `Do you really want to extend request ID ${requestCurrentService.name} expiration by one week?`;
        setConfirmationMessage(confirmationMessage);
    }

    const onServiceUpdateCancel = () => {
        if (editMode == EDIT_MODE_EXTEND_EXPIRY) {
            setEditMode('');
        }
        setConfirmationMessage('');
    }

    const onServiceUpdateConfirm = async () => {

        let data = {};
        let response = null;
        if (serviceNameChangeState) {
            data = { requestID: currentRequestID, serviceID: newServiceForCurrentRequest.id, notifySellers: notifySellers };
            response = await updateRequest(data);
        }
        else if (editMode == EDIT_MODE_EXTEND_EXPIRY) {
            data = { requestID: currentRequestID, extendExpiry: true };
            response = await updateRequest(data);
        }
        else if (showServiceFormModal) {
            data = { requestID: currentRequestID, formData: newServiceFormData };
            response = await updateRequest(data);
        }
        else if (editMode == EDIT_MODE_MARK_SERVICED) {
            response = await await markRequestAsServiced(currentRequestID);
        }

        if (response && response.resStatus == 200) {

            resetState();
            onValidSubmit();
        }
        else {
            setRequestUpdateErrorMessage(response.message);
            setConfirmationMessage('');
            if (editMode == EDIT_MODE_EXTEND_EXPIRY || editMode == EDIT_MODE_MARK_SERVICED) {
                setEditMode('');
            }

        }

    }

    const onEditFormData = (e, serviceRequestID, formData) => {
        setCurrentRequestID(serviceRequestID);
        //setEditMode(EDIT_MODE_CHANGE_FORM);

        setServiceFormData(formData);
        setShowServiceFormModal(true);
        //console.log(formData);
    }

    const onViewFormData = async (e, serviceRequestID, buyerID, timezone) => {
        setCurrentRequestID(serviceRequestID);
        //setEditMode(EDIT_MODE_VIEW_FORM);
        setCurrentRequestBuyerID(buyerID);
        setShowDetailsModal(true);
        setCurrentRequestTimezone(timezone);
        //console.log(formData);
    }

    const onShowBidHistory = async (e, singleBuyerRequestID, requestCurrentService, discountPercent, discountAmount, isRequestAccepted, timezone) => {
        setCurrentRequestID(singleBuyerRequestID);
        setCurrentRequestTimezone(timezone);
        if ((+discountPercent) > 0 || (+discountAmount) > 0) {
            setCurrentRequestDiscount({ discountAmount, discountPercent });
        }

        setServiceRequestIsAccepted(isRequestAccepted);

        setServiceRequestCurrentService(requestCurrentService);
        //setOldServiceID(serviceID);
        //setOldServiceName(serviceName);
        setShowBidHistoryModal(true);
    }

    const onShowNotesModal = (e, singleBuyerRequestID, requestCurrentService) => {
        setCurrentRequestID(singleBuyerRequestID);
        setServiceRequestCurrentService(requestCurrentService);
        setShowNotesModal(true);
    }

    const onNotesModalClose = (isRefresh) => {
        if (isRefresh) {
            // setkeysState({ ...keysState, ServiceRequestNotes: keysState.ServiceRequestNotes + 1 })
        }
        setShowNotesModal(false);
    }

    const getDiscount = (discountPercent, discountAmount) => {
        if ((+discountPercent) > 0 || (+discountAmount) > 0) {
            return { discountAmount, discountPercent }
        } else {
            return {}
        }
    }

    const onShowBidHistoryClose = (isRefresh) => {
        if (isRefresh) {
            //setkeysState({ ...keysState, ServiceRequestBidHistory: keysState.ServiceRequestBidHistory + 1 })
            refreshBidHistoryComponent();
        }
        setShowBidHistoryModal(false);
        //resetState();
    }

    const refreshBidHistoryComponent = () => {
        setkeysState({ ...keysState, ServiceRequestBidHistory: keysState.ServiceRequestBidHistory + 1 })
    }

    const onFormDataEditCancel = () => {
        setEditMode('');
        setServiceFormData({});
    }

    const onValidFormDataSubmit = (formData) => {
        setNewServiceFormData(formData);
        const confirmationMessage = `Do you really want to save new form data for request ID ${currentRequestID}?`;
        setConfirmationMessage(confirmationMessage);
    }

    const isInEditMode = () => {
        if (editMode.length > 0) {
            return true;
        }
        return false;
    }

    const onRequestDetailsModalClose = () => {
        setShowDetailsModal(false);
        //resetState();
    }

    const onRequestServiceFormModalClose = () => {
        setShowServiceFormModal(false);
        //setEditMode('');
    }

    const confirmAcceptHandler = () => {
        setAcceptBidLoading(true);
        acceptBid(selectedBid.sellerBid.sellerBidHistoryID, selectedBid.sellerBid.singleBuyerRequestID, currentRequestBuyerID, paymentFailureOverrride).then((res) => {
            if (res.resStatus === 400) {
                setBidAcceptAttemptIDs([...bidAcceptAttemptIDs, selectedBid.sellerBid.sellerBidHistoryID]);
                setShowBidAcceptanceConfirmationModal(false)
                setAcceptBidError(res.message);
                setShowErrorModal(true);
            }
            else {
                resetState();
                // onValidSubmit();
            }
        }).finally(() => {
            setAcceptBidLoading(false)
        })
    }

    const onShowNotes = (e, singleBuyerRequestID, isRequestAccepted) => {
        setCurrentRequestID(singleBuyerRequestID);
        setServiceRequestIsAccepted(isRequestAccepted);
        setEditMode(EDIT_MODE_VIEW_NOTES);

    }

    const onNotesClose = () => {
        resetState();
    }

    const onSMSClose = () => {
        resetState();
        setEditMode("");
    }

    const onMapClose = () => {
        resetState();
    }

    const onNotifySellerChange = (e, data) => {
        notifySellers = data.checked;
    }

    const getConfirmationContent = () => {
        let a = <div className="content">
            <div className="text">{confirmationMessage}</div>
            {editMode === EDIT_MODE_SERVICE_CHANGE && newServiceForCurrentRequest.categoryID !== serviceRequestCurrentService.categoryID && <div className="notify-seller-container"><Formsy><Checkbox onChange={onNotifySellerChange} name="notifysellers" label="Notify related Pros" /></Formsy></div>}
        </div>;
        return a;
    }

    const onShowMap = (e, serviceRequestID, requestCurrentService, serviceRequestLat, serviceRequestLon, serviceFormData) => {
        setCurrentRequestID(serviceRequestID);
        setCurrentRequestLatLon({ lat: serviceRequestLat, lon: serviceRequestLon });
        setServiceRequestCurrentService(requestCurrentService);
        setServiceFormData(serviceFormData);
        setEditMode(EDIT_MODE_VIEW_MAP);
    }

    const onExpireRequest = async (e, serviceRequestID) => {

        let data = { requestID: serviceRequestID, expireRequest: true };

        const response = await updateRequest(data);
        if (response && response.resStatus == 200) {

            resetState();
            onValidSubmit();
            //setEditMode(editMode);
        }
        else {
            setRequestUpdateErrorMessage(response.message);
            setConfirmationMessage('');
            if (editMode == EDIT_MODE_EXTEND_EXPIRY || editMode == EDIT_MODE_EXPIRE_REQUEST) {
                setEditMode('');
            }

        }

    }

    const onSMSRequest = async (e, singleBuyerRequestID) => {
        setCurrentRequestID(singleBuyerRequestID);
        setEditMode(EDIT_MODE_SMS);
    }


    const onMarkAsServiced = async (e, singleBuyerRequestID) => {
        const confirmationMessage = `Do you really want request ID ${singleBuyerRequestID} to be marked as serviced?`;
        setCurrentRequestID(singleBuyerRequestID);
        setEditMode(EDIT_MODE_MARK_SERVICED);
        setConfirmationMessage(confirmationMessage);


    }

    const toggleSideBar = (sideBarIsOpen) => {
        setSideBarIsOpen(!sideBarIsOpen)
        setIsShowBlurBackground(false);
        setIsSnippetsOpen(false);
        if (!sideBarIsOpen) {
            //this code will run when side bar is open.
            setIsShowBlurBackground(true);
            setTimeout(() => {
                if (selectedServiceRequest.sbr && selectedServiceRequest.sbr.singleBuyerRequestID) {
                    let serviceDiv = document.getElementById("service-request-item-container-" + selectedServiceRequest.sbr.singleBuyerRequestID)
                    if (serviceDiv) {
                        serviceDiv.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    }
                }
            }, 10);
        }
    }

    const searchFeildValueChange = (e, stateName) => {
        setSearchFormState({ ...searchFormState, [stateName]: e.target.value })
    }
    const resetInputFieldValue = (e, stateName) => {
        setSearchFormState({ ...searchFormState, [stateName]: "" })
    }

    const editIconDisabled = (selectedServiceRequest) => {
        if (selectedServiceRequest.sbr) {
            return selectedServiceRequest.sbr.isAccepted || !editRequestEnabled ? true : false
        }
        return true;
    }
    const markServedIconDisabled = (selectedServiceRequest) => {
        if (selectedServiceRequest.sbr) {
            return selectedServiceRequest.sbr.isAccepted && !selectedServiceRequest.sbr.servicedAt ? false : true
        }
        return true;
    }

    const getFormattedBuyerPhoneNumber = (buyer) => {
        if (buyer) {
            return formatPhone(buyer.buyerCellPhone);
        } else {
            return ''
        }
    }

    const initiateBuyerCall = () => {
        console.log(buyerDetailsState);
        if (!startBuyerCall && !startSellerCall) {
            if (buyerDetailsState) {
                setStartBuyerCall(true);

            }
        }
    }

    const onStartSellerCall = () => {
        setStarSellerCall(true);
    }

    const endCall = () => {
        setStartBuyerCall(false);
        setStarSellerCall(false);
    }

    const toogleExpandComponent = (componentName) => {
        setExpandState({ ...expandState, [componentName]: !expandState[componentName] });
    }

    const selectRowhandler = (serviceRequest, checkIsAccepted) => {
        let selectrow = false;
        if (selectedServiceRequest.sbr) {
            if (checkIsAccepted) {
                if (selectedServiceRequest.sbr.singleBuyerRequestID !== serviceRequest.sbr.singleBuyerRequestID && serviceRequest.sbr.isAccepted) {
                    selectrow = true;
                }
            } else {
                if (selectedServiceRequest.sbr.singleBuyerRequestID !== serviceRequest.sbr.singleBuyerRequestID) {
                    selectrow = true;
                }
            }
        } else {
            if (checkIsAccepted) {
                if (serviceRequest.sbr.isAccepted) {
                    selectrow = true;
                }
            } else {
                selectrow = true;
            }
        }
        if (selectrow) {
            setSelectedServiceRequest(serviceRequest);
            setEditMode('');
            setSideBarIsOpen(false);
        }
    }

    const onMouseEnterOnRowItem = (serviceReuqestID) => {
        let selectedDiv = document.getElementById(`blue-bot-${serviceReuqestID}`)
        if (selectedDiv) {
            selectedDiv.classList.add('active');
        }
    }
    const onMouseLeaveOnRowItem = (serviceReuqestID) => {
        let selectedDiv = document.getElementById(`blue-bot-${serviceReuqestID}`)
        if (selectedDiv) {
            selectedDiv.classList.remove('active');
        }
    }

    const toggleSnippets = (isSnippetsOpen) => {
        setIsSnippetsOpen(isSnippetsOpen);
        setIsShowBlurBackground(isSnippetsOpen);
    }

    const hidebackground = () => {
        setIsShowBlurBackground(false);
        setSideBarIsOpen(false);
        setIsSnippetsOpen(false);
    }

    const onRequestAssignmentComplete = (type, message, newManagerUserID) => {
        selectedServiceRequest.sbr.assignedUserID = newManagerUserID;
        setSelectedService(selectedServiceRequest);
        if (type == 'error') {
            NotificationManager.error(message, '', noticationTimeout);
        }
        else {
            NotificationManager.success(message, '', noticationTimeout);
        }

    }

    const handlePhoneChange = (e) => {
        setBuyerNewNumberState(format(e.target.value))
    }

    const onPhoneKeyDown = (evt) => {

        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    const handleEditBuyerNumber = () => {
        setIsBuyerNumberEditState(true)
        setBuyerNewNumberState(format(buyerDetailsState.buyerCellPhone))
    }

    const onBuyerNumberEditSaveClick = async () => {
        let newUpdatedNumber = normalize(buyerNewNumberState);
        let res = await updateBuyer(buyerDetailsState.buyerID, newUpdatedNumber);
        if (res.resStatus = 200) {
            setBuyerDetailsState({ ...buyerDetailsState, buyerCellPhone: newUpdatedNumber })
            setIsBuyerNumberEditState(false)
        }
    }

    const onBuyerNumberEditCancel = () => {
        setIsBuyerNumberEditState(false)
        setBuyerNewNumberState(format(buyerDetailsState.buyerCellPhone))
    }

    const copyBuyerNumber = () => {
        if (navigator.clipboard) {
            let newUpdatedNumber = normalize(buyerNewNumberState);
            navigator.clipboard.writeText(newUpdatedNumber)
                .then(() => {
                    setBuyerPhoneNoCopyToolTipText("Copied!")
                })
        } else {
            alert("Copy operation does not supported in this browser. ")
        }
    }

    const onConfirmPriceClick = (e, serviceRequestID, formData) => {
        setCurrentRequestID(serviceRequestID);
        setShowConfirmPriceModal(true);
    }

    const onConfirmationPriceChange = (e, data) => {
        setConfirmationPrice(data.value);
    }

    const onPriceConfirmationSubmit = async () => {
        const res = await setPriceConfirmation(selectedServiceRequest.sbr.singleBuyerRequestID,  confirmationPrice);
        if(res.resStatus == 200){
            selectedServiceRequest.sbr.confirmedPrice = confirmationPrice;
            setSelectedServiceRequest(selectedServiceRequest);
            setShowConfirmPriceModal(false);
            NotificationManager.success('Confirmed price has been saved.', '', noticationTimeout);
        }
    }

    const resetConfirmationPrice = async () => {
        const res = await resetPriceConfirmation(selectedServiceRequest.sbr.singleBuyerRequestID);
        if(res.resStatus == 200){
            setShowConfirmPriceModal(false);
            selectedServiceRequest.sbr.confirmedPrice = undefined;
            setSelectedServiceRequest(selectedServiceRequest);
            NotificationManager.success('Confirmed price has been reset.', '', noticationTimeout);
        }
    }
 
    return (
        <>
            {/* <NotificationContainer /> */}
            <div className={"request-form-container-new"}>
                {
                    // sideBarIsOpen ? <div onClick={selectedServiceRequest.sbr ? (e) => toggleSideBar(sideBarIsOpen) : () => { }} className={"bg-blur"}> </div> : ""
                    // (sideBarIsOpen || isSnippetsOpen) 
                    ((sideBarIsOpen || isSnippetsOpen)) && isShowBlurBackground && selectedServiceRequest.sbr ? <div onClick={(e) => hidebackground()  /*toggleSideBar(sideBarIsOpen)*/} className={"bg-blur"}> </div> : ""
                }

                <div key="top-panel" className="master-top-panel"
                // ref={this.pageTopRef}
                >
                    <div className="content-panel">
                        <div className="top-bar-new">
                            <Menu className="master-menu">
                                <Menu.Item header className="header-logo">
                                    <a href="/">
                                        <img
                                            src={logo_new}
                                            className="logo" /></a>
                                </Menu.Item>

                                {selectedServiceRequest.sbr && windowSize.width >= 768 ?

                                    <>
                                        <Menu.Item header className="menu-item-container request-id-container">
                                            <div className={"heading-name"}>
                                                {"Request"}
                                            </div>
                                            <div className={"heading-text"}>
                                                {"  " + selectedServiceRequest.sbr.singleBuyerRequestID}
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item header className="menu-item-container buyer-name-container">
                                            <div className={"heading-name"}>
                                                {"Buyer "}
                                            </div>
                                            {
                                                isBuyerNumberEditState ?
                                                    <div className={"buyer-number-edit-container"}>
                                                        <Formsy ref={formRef} onValidSubmit={() => { }}>
                                                            <DGTextbox name="cellnumber"
                                                                label="" placeholder="" required type="text"
                                                                maxLength={14}
                                                                tabIndex={2}
                                                                // icon={fieldPhoneIcon}
                                                                validations={{
                                                                    isValidCellNumber: true
                                                                }}
                                                                validationErrors={{
                                                                    isDefaultRequiredValue: 'This field is required',
                                                                    isValidCellNumber: 'Invalid Cell Number'
                                                                }}
                                                                onChange={(e) => handlePhoneChange(e)}
                                                                onKeyDown={(e) => onPhoneKeyDown(e)}
                                                                value={buyerNewNumberState ? format(buyerNewNumberState) : ""}
                                                            />
                                                            <div className={`buyer-edit-icons-container`}>
                                                                <div data-tooltip="Save" data-position="top center" data-inverted="" className={`save-icon-container ${_.isEmpty(buyerNewNumberState) || buyerNewNumberState == format(buyerDetailsState.buyerCellPhone) || buyerNewNumberState.length != 14 ? "disabled" : ""}`} onClick={_.isEmpty(buyerNewNumberState) || buyerNewNumberState == format(buyerDetailsState.buyerCellPhone) || buyerNewNumberState.length != 14 ? () => { } : (e) => onBuyerNumberEditSaveClick()} >
                                                                    <svg className="save-icon" xmlns="http://www.w3.org/2000/svg" width="22.137" height="15.309" viewBox="0 0 22.137 15.309">
                                                                        <path id="Path_29165" data-name="Path 29165" d="M735.7,189.278c1.225-.97,2.413-1.916,3.606-2.854q3.56-2.8,7.126-5.591c.538-.422,1.069-.853,1.614-1.266a1.553,1.553,0,0,1,1.314-.367,1.076,1.076,0,0,1,.772,1.562,2.625,2.625,0,0,1-.51.706q-6.171,6.174-12.355,12.335a2.132,2.132,0,0,1-3.1.011q-2.727-2.7-5.433-5.424a2.139,2.139,0,0,1-.048-2.961,2.115,2.115,0,0,1,2.974-.157c.882.811,1.712,1.68,2.562,2.525C734.711,188.285,735.2,188.777,735.7,189.278Z" transform="translate(-728.113 -179.168)" fill="#7ac943" />
                                                                    </svg>
                                                                </div>
                                                                <div data-tooltip="Cancel" data-position="top center" data-inverted="" className={`cancel-icon-container`} onClick={onBuyerNumberEditCancel} >
                                                                    <svg className="cancel-icon" xmlns="http://www.w3.org/2000/svg" width="14.085" height="14.085" viewBox="0 0 14.085 14.085">
                                                                        <g id="Group_15496" data-name="Group 15496" transform="translate(0.5 0.585)">
                                                                            <path id="Close-2" data-name="Close" d="M.263,12.738a.9.9,0,0,0,1.269,0L6.5,7.769l4.969,4.969a.9.9,0,0,0,1.269-1.269L7.769,6.5l4.969-4.969A.9.9,0,1,0,11.469.263L6.5,5.231,1.532.263A.9.9,0,0,0,.263,1.532L5.231,6.5.263,11.469A.9.9,0,0,0,.263,12.738Z" transform="translate(0 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </Formsy>
                                                    </div>
                                                    :
                                                    <div className={"heading-text"}>
                                                        {((buyerCallingEnabled && selectedServiceRequest.sbr.assignedUserID == currentUser.userID) || callAnyoneEnabled) ?
                                                        <div className='buyer-calling' onClick={initiateBuyerCall}><Icon name='phone' className="seller-phone-icon"> </Icon></div>
                                                        :
                                                        <a href={`tel:${getFormattedBuyerPhoneNumber(buyerDetailsState)}`}> <Icon name='phone' className="seller-phone-icon"> </Icon></a>
                                                        }
                                                        {buyerDetailsState.buyerName}
                                                        <span className={`buyer-number-display ${buyerNumberEditEnabled ? "" : " edit-disabled"}`} onClick={buyerNumberEditEnabled ? () => handleEditBuyerNumber() : () => { }}>
                                                            {!_.isEmpty(buyerDetailsState.buyerCellPhone) ? `(${buyerDetailsState.buyerCellPhone}) ` : ''}
                                                        </span>

                                                        <span data-tooltip={buyerPhoneNoCopyToolTipText} data-position="top center" data-inverted=""
                                                            onMouseLeave={() => setBuyerPhoneNoCopyToolTipText("Copy")}
                                                            onMouseEnter={() => setBuyerPhoneNoCopyToolTipText("Copy")}
                                                            onClick={() => copyBuyerNumber()}
                                                            className={"buyer-no-copy-icon"}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg" width="13.312" height="12.536" viewBox="0 0 13.312 12.536">
                                                                <g id="Group_16193" data-name="Group 16193" transform="translate(0.15 0.15)">
                                                                    <g id="Group_16198" data-name="Group 16198" transform="translate(0 0)">
                                                                        <path id="Path_29436" data-name="Path 29436" d="M10.773,78.262H0V68.276H10.773Zm-.744-9.254H9.847q-4.465,0-8.93,0c-.145,0-.2.03-.2.188q.008,4.078,0,8.157c0,.054.005.107.008.164h9.294Z" transform="translate(0 -66.026)" stroke="#377DFF" fill="#377DFF" stroke-width="0.3" />
                                                                        <path id="Path_29437" data-name="Path 29437" d="M86.724.738H76.972V0H87.448V9.661h-.725Z" transform="translate(-74.436 0)" stroke="#377DFF" fill="#377DFF" stroke-width="0.3" />
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                            }
                                        </Menu.Item>
                                        <Menu.Item header className="menu-item-container initiated-date-container">
                                            <div className={"heading-name"}>
                                                {"Initiated On "}
                                            </div>
                                            <div className={"heading-text"}>
                                                {moment(selectedServiceRequest.sbr.initiated).format('MMM DD YYYY')}
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item header className="menu-item-container expiry-date-container">
                                            <div>
                                                <svg className={`top-arrow ${selectedServiceRequest.sbr.isAccepted ? "accpeted" : ""} ${selectedServiceRequest.sbr.servicedAt ? "serviced" : ""}`} xmlns="http://www.w3.org/2000/svg" width="17.255" height="8.627" viewBox="0 0 17.255 8.627">
                                                    <path id="Path_29119" data-name="Path 29119" d="M-5717.5,10588.752l8.627,8.627-8.627,8.628Z" transform="translate(10606.007 5717.5) rotate(90)" fill="#ff5457" />
                                                </svg>

                                            </div>
                                            <div className={"heading-name"} style={{ marginBottom: selectedServiceRequest.sbr.isAccepted || selectedServiceRequest.sbr.servicedAt ? '0' : '5px' }}>
                                                {
                                                    selectedServiceRequest.sbr.isAccepted || selectedServiceRequest.sbr.servicedAt ? "" : "Expiring On"
                                                }

                                            </div>
                                            <div style={{ display: "inline" }} className={` ${moment(selectedServiceRequest.sbr.expiry) < moment() ? 'expired expired-new' : ''} ${selectedServiceRequest.sbr.isAccepted || selectedServiceRequest.sbr.servicedAt ? " service-status-tag " : ""} `}>
                                                {
                                                    // on top bar
                                                    <ExpiredColumn request={selectedServiceRequest} />
                                                }
                                            </div>
                                            {!selectedServiceRequest.sbr.isAccepted &&
                                                <div style={{ margin: '0px 5px ', display: "inline-block", height: '33px' }}>

                                                    <div data-tooltip="Extend Request" data-position="bottom center" data-inverted="" className={"icon-container"}>
                                                        <img src={extend_icon} className="icon" onClick={(e) => onExtendExpiryClick(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.service)} />
                                                    </div>

                                                    {
                                                        moment(selectedServiceRequest.sbr.expiry) < moment() ? "" :
                                                            <div data-tooltip="Expire Request" data-position="bottom center" data-inverted="" className={"icon-container"}>
                                                                <img src={expiry_icon} className="icon" onClick={(e) => onExpireRequest(e, selectedServiceRequest.sbr.singleBuyerRequestID)} />
                                                            </div>
                                                    }

                                                </div>
                                            }
                                        </Menu.Item>
                                        <Menu.Item header className="menu-item-container quick-info-container">
                                            <div className={"heading-name"}>
                                                {"Quick Info"}
                                            </div>
                                            <div className={"heading-text quick-info-text"}>
                                                {selectedServiceRequest.sbr.quickInfo}
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item
                                            header className="menu-item-container view-edit-icon-container">
                                            <div className={"icons-container"}>
                                                <div data-tooltip="View Details" data-position="bottom center" data-inverted="" className={"view-icon-container"} onClick={(e) => onViewFormData(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.sbr.buyerID, selectedServiceRequest.sbr.timezone)} >
                                                    <img src={detail_eye} className="view-icon" />
                                                </div>
                                                <div data-tooltip="Edit" data-position="bottom center" data-inverted="" className={`edit-icon-container ${editIconDisabled(selectedServiceRequest) ? "disabled" : ""}`} onClick={editIconDisabled(selectedServiceRequest) ? () => { } : (e) => onEditFormData(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.sbr.serviceFormData)}  >
                                                    <img src={edit_pen} className="edit-icon" />
                                                </div>
                                                <div data-tooltip="Mark Serviced" data-position="bottom center" data-inverted="" className={`mark-service-icon-container ${markServedIconDisabled(selectedServiceRequest) ? "disabled" : ""}`} onClick={markServedIconDisabled(selectedServiceRequest) ? () => { } : (e) => onMarkAsServiced(e, selectedServiceRequest.sbr.singleBuyerRequestID)} >
                                                    {/* <Icon className={"mark-service-icon"} name="thumbs up outline" size='large' ></Icon> */}
                                                    <img src={mark_serviced_icon} className="mark-service-icon" />
                                                </div>
                                                {checkManagerAuthorization(featuresList.SET_SBR_CONFIRMATION_PRICE, currentUser) ? <div data-tooltip="Confirm Price" data-position="bottom center" data-inverted="" className={`confirm-price-icon-container ${editIconDisabled(selectedServiceRequest) ? "disabled" : ""}`} onClick={editIconDisabled(selectedServiceRequest) ? () => { } : (e) => onConfirmPriceClick(e, selectedServiceRequest.sbr.singleBuyerRequestID)}  >
                                                    <img src={confirm_price_icon} className="confirm-price-icon" />
                                                </div> : ""}
                                            </div>
                                        </Menu.Item>
                                        {checkManagerAuthorization(featuresList.SET_SBR_CONFIRMATION_PRICE, currentUser) && selectedServiceRequest.sbr.confirmedPrice ?  <Menu.Item header className="menu-item-container sbr-confirmation-price-container">
                                        <div className={"sbr-confirmation-price"}>
                                        ${selectedServiceRequest.sbr.confirmedPrice}
                                            </div> 
                                            
                                        </Menu.Item>
                                        : ""}
                                        {(requestAssignmentEnabled || selectedServiceRequest.sbr.assignedUserID > 0) &&

                                            <Menu.Item
                                                header className="menu-item-container view-edit-icon-container">
                                                <ServiceRequestAssignment managerUsers={managerUsers} request={selectedServiceRequest} requestAssignmentEnabled={requestAssignmentEnabled} onAssignmentComplete={onRequestAssignmentComplete} />
                                            </Menu.Item>
                                        }
                                        {
                                            requestTextingEnabled && <Menu.Item
                                                header className="menu-item-container view-edit-icon-container">
                                                <ToggleTextingForSBRContainer enableTexting={selectedServiceRequest.sbr.enableTexting} sbrID={selectedServiceRequest.sbr.singleBuyerRequestID} />
                                            </Menu.Item>
                                        }
                                    </>
                                    : ""}
                                <Menu.Menu position='right' className={`top-bar-links ${selectedServiceRequest.sbr && windowSize.width > 768 ? "toward-right" : ""}`}>
                                    {!props.loggedIn && windowSize.width >= 768 &&

                                        <Menu.Item>
                                            <Button className="button-primary" href="/signin">Login</Button>
                                        </Menu.Item>
                                    }
                                    {!props.loggedIn && windowSize.width < 1024 &&
                                        <Menu.Item>
                                            <Dropdown className="responsive-menu" trigger={<img src={hamburger_icon} />}>
                                                <Dropdown.Menu>
                                                    {windowSize.width < 768 &&
                                                        <Dropdown.Item key='menu_login'>

                                                            <Button className="button-primary" href="/signin">Login</Button>
                                                        </Dropdown.Item>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Menu.Item>
                                    }
                                    {props.loggedIn &&
                                        <Menu.Item>
                                            <Dropdown className="loggedin-user" text={`${currentUser.firstName.charAt(0)}`} >
                                                <Dropdown.Menu>
                                                    <div className="balloon">
                                                        <div>
                                                            <div>{`${currentUser.firstName.charAt(0)}`}</div>
                                                        </div>
                                                        <div className={"user-name"}>
                                                            <p>
                                                                {`${currentUser.firstName} ${currentUser.lastName}`}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <Dropdown.Item key="service-request" text="Service Requests" onClick={() => {
                                                        history('/',
                                                            { state: { visitTime: moment().unix() } }
                                                        );
                                                    }} icon="search" />
                                                    {checkManagerAuthorization(featuresList.BUSINESS_PROFILE, currentUser) ?
                                                        <Dropdown.Item key="seller-profile" text="Business Profile" onClick={() => {
                                                            history('/seller-profile',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.BUSINESS_REVIEWS, currentUser) ?
                                                        <Dropdown.Item key="seller-reviews" text="Business Reviews" onClick={() => {
                                                            history('/seller-reviews',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.MESSENGER, currentUser) ?
                                                        <Dropdown.Item key="messenger" text="Messenger" onClick={() => {
                                                            history('/messenger',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.RADIUS_CHECK, currentUser) ?
                                                        <Dropdown.Item key="radius-check" text="Radius Check" onClick={() => {
                                                            history(NavigationUrls.RADIUS_CHECK,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="search" /> : ""}
                                                    {checkManagerAuthorization(featuresList.SUBSCRIPTIONS_SEARCH, currentUser) ?
                                                        <Dropdown.Item key="subscription-search" text="Subscriptions" onClick={() => {
                                                            history(NavigationUrls.SUBSCRIPTION_SEARCH,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.TRIAL_SUBSCRIPTIONS, currentUser) ?
                                                        <Dropdown.Item key="trial-subscription" text="Trial Subscription" onClick={() => {
                                                            history('/trial-subscription',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.SAAS_METRICS, currentUser) ?
                                                        <Dropdown.Item key="saas-metrics" text="SAAS Metrics" onClick={() => {
                                                            history(
                                                                NavigationUrls.SAAS_METRICS,
                                                                { state: { visitTime: moment().unix() } }
                                                            );

                                                        }} icon="chart bar" /> : ""}
                                                    {checkManagerAuthorization(featuresList.FAILED_COMMISSION_PAYMENTS, currentUser) ?
                                                        <Dropdown.Item key="failed-commission-payments" text="Failed Commission Payments" onClick={() => {
                                                            history('/failed-commission-payments',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.FAILED_SUBSCRIPTION_PAYMENTS, currentUser) ?
                                                        <Dropdown.Item key="failed-subscription-payments" text="Failed Subscription Payments" onClick={() => {
                                                            history('/failed-subscription-payments',
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.COMMISSION_PAYMENTS, currentUser) ?
                                                        <Dropdown.Item key="commission-payment" text="Commission Payments" onClick={() => {
                                                            history(NavigationUrls.COMMISSION_PAYMENTS,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.ACCOUNTS_DASHBOARD, currentUser) ?
                                                        <Dropdown.Item key="accounts-dashboard" text="Accounts Dashboard" onClick={() => {
                                                            history(NavigationUrls.ACCOUNTS_DASHBOARD,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="chart area" /> : ""}
                                                    {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, currentUser) ?
                                                        <Dropdown.Item text="Add Seller Subscription" onClick={() => {
                                                            history(NavigationUrls.ADD_SUBSCRIPTION,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}

                                                    {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, currentUser) ?
                                                        <Dropdown.Item text="Add Commission Only Subscription" onClick={() => {
                                                            history(
                                                                NavigationUrls.ADD_COMMISSION_ONLY_SUBSCRIPTION,
                                                                { state: { visitTime: moment().unix() } }
                                                            );

                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.REQUEST_DASHBOARD, currentUser) ?
                                                        <Dropdown.Item text="Request Dashboard" onClick={() => {
                                                            history(NavigationUrls.REQUEST_DASHBOARD,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="dashboard" /> : ""}


                                                    {<Dropdown.Item text="AM Dashboard" onClick={() => {
                                                        history(NavigationUrls.AM_DASHBOARD,
                                                            { state: { visitTime: moment().unix() } }
                                                        );
                                                    }} icon="dashboard" />}

                                                    {checkManagerAuthorization(featuresList.FILL_RATE, currentUser) ?
                                                        <Dropdown.Item text="Fill Rate" onClick={() => {
                                                            history(NavigationUrls.USERS_FILLRATE_DASHBOARD,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="user" /> : ""}
                                                    {checkManagerAuthorization(featuresList.WEEKLY_FILL_RATE, currentUser) ?
                                                        <Dropdown.Item text="Weekly Fill Rate" onClick={() => {
                                                            history(NavigationUrls.USERS_WEEKLY_FILLRATE,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="chart area" /> : ""}
                                                    {checkManagerAuthorization(featuresList.CHURN_CANDIDATES, currentUser) ?
                                                        <Dropdown.Item text="Churn Candidates" onClick={() => {
                                                            history(NavigationUrls.CHURN_CANDIDATES,
                                                                { state: { visitTime: moment().unix() } }
                                                            );
                                                        }} icon="users" /> : ""}
                                                    {checkManagerAuthorization(featuresList.SHOW_PAYMENT_PLANS, currentUser) ?
                                                                <Dropdown.Item text="Payment Plans" onClick={() => {
                                                                    history(
                                                                        NavigationUrls.PAYMENT_PLANS,
                                                                        { state: { visitTime: moment().unix() } }
                                                                    );

                                                                }} icon="money bill alternate outline" /> : ""}
                                                    {(checkManagerAuthorization(featuresList.IMPERSONATE_BUYER, currentUser) || checkManagerAuthorization(featuresList.IMPERSONATE_SELLER, currentUser)) ?
                                                                    <Dropdown.Item text="Impersonate User" onClick={() => {
                                                                        history(
                                                                            NavigationUrls.IMPERSONATE_USER,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                }} icon="user secret" /> : ""}
                                                    {(checkManagerAuthorization(featuresList.ACTUAL_COMMISSION_REVENUE, currentUser) ) ?
                                                                    <Dropdown.Item text="Daily Lead Fee Revenue" onClick={() => {
                                                                        history(
                                                                            NavigationUrls.ACTUAL_COMMISSION_REVENUE,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                }} icon="chart area" /> : ""}

                                                    {(checkManagerAuthorization(featuresList.SET_SELLER_PWD, currentUser) ) ?
                                                                    <Dropdown.Item text="Set Seller Password" onClick={() => {
                                                                        history(
                                                                            NavigationUrls.SET_SELLER_PWD,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                }} icon="key" /> : ""}

                                                    {(checkManagerAuthorization(featuresList.SELLER_LIST_BY_ACCEPTING_JOB, currentUser) ) ?
                                                        <Dropdown.Item text="Accepting Jobs" onClick={() => {
                                                            history(
                                                                NavigationUrls.SELLER_LIST_BY_ACCEPTING_JOB,
                                                                { state: { visitTime: moment().unix() } }
                                                            );

                                                    }} icon="dashboard" /> : ""}          
                                                    {(checkManagerAuthorization(featuresList.SELLER_CATEGORY_RADIUS, currentUser)) ?
                                                        <Dropdown.Item text="Seller Category Radius" onClick={() => {
                                                            history(
                                                                NavigationUrls.SELLER_CATEGORY_RADIUS,
                                                                { state: { visitTime: moment().unix() } }
                                                            );

                                                    }} icon="circle outline" /> : ""} 

                                                    <Dropdown.Item text="Sign Out" icon="sign-out" onClick={logout} />
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Menu.Item>
                                    }
                                </Menu.Menu>
                            </Menu>
                        </div>
                    </div>
                </div>
                <div className="main-page-panel">
                    <div className={`content-panel-side-bar ${sideBarIsOpen ? "expand" : ""}`}>
                        {
                            windowSize.width > 768 ?
                                <div className="header-logo">
                                    {/* "https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/dealgrace-marketplace-white_1gmhg63kktxlce29_.svg" */}
                                    <a href="/">
                                        <img src={sideBarIsOpen ? logo_new_full : logo_new} className="logo" /></a>
                                </div> : ""
                        }
                        <div className={"side-bar-service-name"}>
                            {
                                sideBarIsOpen && windowSize.width > 768 ? "" : selectedServiceRequest.service ? selectedServiceRequest.service.name : ""
                            }
                        </div>
                        <div className={`side-bar-toggle-btn-container ${sideBarIsOpen ? "expand" : ""}`} onClick={(e) => toggleSideBar(sideBarIsOpen)}>
                            <svg className={`side-bar-toggle-btn-icon ${sideBarIsOpen ? "expand" : ""}`} xmlns="http://www.w3.org/2000/svg" width="12.678" height="11.086" viewBox="0 0 12.678 11.086">
                                <g id="Group_13355" data-name="Group 13355" transform="translate(0 11.086) rotate(-90)">
                                    <path id="Path_11536" data-name="Path 11536" d="M5.506,4a2.328,2.328,0,0,0-.238-.389Q3.643,1.979,2.006.36A1.162,1.162,0,0,0,.09,1.6a1.746,1.746,0,0,0,.362.5Q2.534,4.193,4.628,6.267a1.192,1.192,0,0,0,1.861,0q2.1-2.1,4.181-4.2A1.171,1.171,0,1,0,9.012.423Q7.408,2,5.82,3.6C5.736,3.686,5.67,3.789,5.506,4Z" transform="translate(0.002 5.964)" opacity="0.4" />
                                    <path id="Path_11537" data-name="Path 11537" d="M5.567,3.9C4.37,2.7,3.228,1.569,2.091.431A1.191,1.191,0,0,0,.863.05,1.145,1.145,0,0,0,.225,1.843a2.3,2.3,0,0,0,.263.3Q2.527,4.171,4.567,6.2a1.226,1.226,0,0,0,1.983.011Q8.62,4.14,10.678,2.058A1.171,1.171,0,1,0,9.038.4c-1.077,1.059-2.144,2.13-3.213,3.2C5.739,3.678,5.669,3.777,5.567,3.9Z" transform="translate(0 0)" opacity="0.7" />
                                </g>
                            </svg>
                        </div>
                        <div className={`search-form-container ${sideBarIsOpen ? "expand" : "hide"}`}>
                            {
                                sideBarIsOpen ?
                                    <>
                                        <Message negative hidden={!showFilterErrorMessage}>
                                            <Message.Header>Cannot proceed</Message.Header>
                                            <p>Please provide values for Request ID or Phone Number</p>
                                        </Message>
                                        <div className={"side-bar-heading"}>
                                            {"Service Requests"}
                                        </div>
                                        <div className="filters">
                                            <Formsy ref={formRef} onValidSubmit={onValidSubmit}>
                                                <div>
                                                    <Grid relaxed='very' stackable>
                                                        <Grid.Row>
                                                            <Grid.Column>
                                                                <DGTextbox showresetbutton key='search-filter-servicerequest-list' name="requestID"
                                                                    label="Request ID"
                                                                    validations={{
                                                                        isNumeric: true
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: `This field must be a number`

                                                                    }}
                                                                    innerRef={(c) => {
                                                                        requestIDFilterInputRef = c;
                                                                    }}
                                                                    placeholder={"Ex : 1"}
                                                                    value={searchFormState.requestID}
                                                                    onChange={(e) => searchFeildValueChange(e, "requestID")}
                                                                    onReset={(e) => resetInputFieldValue(e, "requestID")}
                                                                />
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                    <Divider horizontal>AND/OR</Divider>
                                                    <Grid relaxed='very' stackable>
                                                        <Grid.Row>
                                                            <Grid.Column>
                                                                <DGTextbox showresetbutton key='search-filter-servicerequest-list' name="cellNumber"
                                                                    label="Phone Number"
                                                                    maxLength="10"
                                                                    validations={{
                                                                        isNumeric: true
                                                                    }}
                                                                    validationErrors={{
                                                                        isNumeric: `This field can only contain numbers`

                                                                    }}
                                                                    placeholder={"Ex: 00000000000"}
                                                                    value={searchFormState.cellNumber}
                                                                    onChange={(e) => searchFeildValueChange(e, "cellNumber")}
                                                                    onReset={(e) => resetInputFieldValue(e, "cellNumber")}
                                                                />
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                    <div>
                                                        <button type="submit" className="button-submit" >Search</button>
                                                    </div>
                                                </div>
                                            </Formsy>
                                        </div>
                                        <div className={"divider"}></div>
                                        <div className="service-list-container">
                                            {
                                                isEmpty(serviceRequestList) ?
                                                    <div className={"loading-container"}>
                                                        <img src={list_loading}></img>
                                                    </div>
                                                    :
                                                    <div className={"service-list-inner-container"}>
                                                        {
                                                            !isEmpty(serviceRequestList) && serviceRequestList.map((serviceRequest) => {
                                                                return (
                                                                    <>
                                                                        <div id={`blue-bot-${serviceRequest.sbr.singleBuyerRequestID}`} className={`blue-dot-container ${selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? "" : "no-selected" : "no-selected"}`}
                                                                            onClick={() => selectRowhandler(serviceRequest, false)
                                                                                //selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? () => { } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); }
                                                                            }
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                                                                                <g id="Group_13425" data-name="Group 13425" transform="translate(-18 -700)">
                                                                                    <circle id="Ellipse_355" data-name="Ellipse 355" cx="7.5" cy="7.5" r="7.5" transform="translate(18 700)" fill="#ebfffe" />
                                                                                    <circle id="Ellipse_356" data-name="Ellipse 356" cx="3.5" cy="3.5" r="3.5" transform="translate(22 704)" fill="#03d6cb" />
                                                                                </g>
                                                                            </svg>
                                                                        </div>
                                                                        <div id={`service-request-item-container-${serviceRequest.sbr.singleBuyerRequestID}`} className={`service-request-item-container ${selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? "selected" : "" : ""}`} onMouseEnter={() => onMouseEnterOnRowItem(serviceRequest.sbr.singleBuyerRequestID)} onMouseLeave={() => onMouseLeaveOnRowItem(serviceRequest.sbr.singleBuyerRequestID)} >
                                                                            {
                                                                                selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ?
                                                                                    <div className={"top-bar"}></div> : "" : ""
                                                                            }
                                                                            <div className={"row"}
                                                                                onClick={() => selectRowhandler(serviceRequest, false)
                                                                                    //selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? () => { } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); }
                                                                                }
                                                                            >
                                                                                <div className={"row-heading"}>
                                                                                    {"Request ID"}
                                                                                </div>
                                                                                <div className={"row-value"}
                                                                                >
                                                                                    {serviceRequest.sbr.singleBuyerRequestID}
                                                                                </div>
                                                                            </div>
                                                                            <div className={"row"} //onClick={() => selectRowhandler(serviceRequest, true)
                                                                            //selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID || !serviceRequest.sbr.isAccepted ? () => { } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); }
                                                                            //}
                                                                            >
                                                                                <div className={"row-heading"} onClick={() => selectRowhandler(serviceRequest, false)}>
                                                                                    {"Service"}
                                                                                </div>
                                                                                <div className={"row-value"} onClick={() => selectRowhandler(serviceRequest, true)}>
                                                                                    {!serviceRequest.sbr.isAccepted &&
                                                                                        <React.Fragment>
                                                                                            <div className={(serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ? 'service-title edit' : 'service-title'}
                                                                                                style={{ pointerEvents: isInEditMode() ? 'none' : 'auto' }}
                                                                                                onClick={(e) => onEditServiceClick(e, serviceRequest.sbr.singleBuyerRequestID, serviceRequest.service, serviceRequest.sbr.lat, serviceRequest.sbr.lon)}>
                                                                                                {serviceRequest.service.name}
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    }
                                                                                    {serviceRequest.sbr.isAccepted &&
                                                                                        <div>{serviceRequest.service.name} </div>
                                                                                    }
                                                                                    {(serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ?
                                                                                        <React.Fragment>
                                                                                            <SearchServiceControl setSelectedService={setSelectedService} skipServiceID={serviceRequest.service.serviceID} />

                                                                                            {/* <div className="edit-icons">
                                                                                                <Button primary ref={updateIconRef}  {...
                                                                                                    {
                                                                                                        disabled: (_.isEmpty(newServiceForCurrentRequest) ? true : false)
                                                                                                    }}
                                                                                                    animated='vertical' onClick={onChangeServiceClick}>
                                                                                                    <Button.Content hidden>Save</Button.Content>
                                                                                                    <Button.Content visible>
                                                                                                        <Icon name='check circle' />
                                                                                                    </Button.Content>
                                                                                                </Button>
                                                                                                <Button
                                                                                                    animated='vertical' onClick={onServiceEditCancel}>
                                                                                                    <Button.Content hidden>Cancel</Button.Content>
                                                                                                    <Button.Content visible>
                                                                                                        <Icon name='delete' />
                                                                                                    </Button.Content>
                                                                                                </Button>

                                                                                            </div> */}
                                                                                        </React.Fragment> : ""
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className={"row no-border"}
                                                                            //onClick={() => selectRowhandler(serviceRequest, true)
                                                                            //selectedServiceRequest.sbr ? (selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID || !serviceRequest.sbr.isAccepted) ? () => { } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); } : () => { setSelectedServiceRequest(serviceRequest); setEditMode(''); setSideBarIsOpen(false); }
                                                                            //}
                                                                            >
                                                                                <div className={"row-heading"} onClick={() => selectRowhandler(serviceRequest, false)}>
                                                                                    {"Expiring On"}
                                                                                </div>
                                                                                <div className={"row-value expiry-date-container"} onClick={() => selectRowhandler(serviceRequest, true)}>
                                                                                    <div style={{ display: "inline !important" }} className={`${moment(serviceRequest.sbr.expiry) < moment() ? 'expired expired-new' : ''}  ${(serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ? "no-icons" : ""}`}>
                                                                                        {
                                                                                            // in side bar list
                                                                                            <ExpiredColumn request={serviceRequest} />
                                                                                        }
                                                                                        {serviceRequest.sbr && !serviceRequest.sbr.isAccepted ?
                                                                                            <>
                                                                                                {
                                                                                                    (serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ? "" :
                                                                                                        <div style={{ margin: '0px 5px ', display: "inline-block", height: '33px' }}>

                                                                                                            <div data-tooltip="Extend Request" data-position="bottom center" data-inverted="" className={"icon-container"}>
                                                                                                                <img src={extend_icon} className="icon" onClick={(e) => onExtendExpiryClick(e, serviceRequest.sbr.singleBuyerRequestID, serviceRequest.service)} />
                                                                                                            </div>
                                                                                                            {
                                                                                                                moment(serviceRequest.sbr.expiry) < moment() ? "" :
                                                                                                                    <div data-tooltip="Expire Request" data-position="bottom center" data-inverted="" className={"icon-container"}>
                                                                                                                        <img src={expiry_icon} className="icon" onClick={(e) => onExpireRequest(e, serviceRequest.sbr.singleBuyerRequestID)} />
                                                                                                                    </div>
                                                                                                            }
                                                                                                        </div>
                                                                                                }

                                                                                            </> : ""
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className={"view-edit-icon-container"}>
                                                                            <div className={"top-arrow"}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6">
                                                                                    <path id="Polygon_8" data-name="Polygon 8" d="M5,0l5,6H0Z" fill="#d9d9d9" />
                                                                                </svg>
                                                                            </div>
                                                                            <div className={`icons-container ${serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID ? "small" : ""}`}>
                                                                                {
                                                                                    (serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ?
                                                                                        <>
                                                                                            <div data-tooltip="Save" data-position="top center" data-inverted="" className={`save-icon-container ${_.isEmpty(newServiceForCurrentRequest) ? "disabled" : ""}`} onClick={_.isEmpty(newServiceForCurrentRequest) ? () => { } : (e) => onChangeServiceClick()} >
                                                                                                {/* <img src={edit_pen} className="edit-icon" /> */}
                                                                                                <svg className="save-icon" xmlns="http://www.w3.org/2000/svg" width="22.137" height="15.309" viewBox="0 0 22.137 15.309">
                                                                                                    <path id="Path_29165" data-name="Path 29165" d="M735.7,189.278c1.225-.97,2.413-1.916,3.606-2.854q3.56-2.8,7.126-5.591c.538-.422,1.069-.853,1.614-1.266a1.553,1.553,0,0,1,1.314-.367,1.076,1.076,0,0,1,.772,1.562,2.625,2.625,0,0,1-.51.706q-6.171,6.174-12.355,12.335a2.132,2.132,0,0,1-3.1.011q-2.727-2.7-5.433-5.424a2.139,2.139,0,0,1-.048-2.961,2.115,2.115,0,0,1,2.974-.157c.882.811,1.712,1.68,2.562,2.525C734.711,188.285,735.2,188.777,735.7,189.278Z" transform="translate(-728.113 -179.168)" fill="#7ac943" />
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div data-tooltip="Cancel" data-position="left center" data-inverted="" className={`cancel-icon-container`} onClick={onServiceEditCancel} >
                                                                                                {/* <img src={mark_serviced_icon} className="mark-service-icon" /> */}
                                                                                                <svg className="cancel-icon" xmlns="http://www.w3.org/2000/svg" width="14.085" height="14.085" viewBox="0 0 14.085 14.085">
                                                                                                    <defs>
                                                                                                        <clipPath id="clip-path">
                                                                                                            <path id="Close" d="M.263,12.738a.9.9,0,0,0,1.269,0L6.5,7.769l4.969,4.969a.9.9,0,0,0,1.269-1.269L7.769,6.5l4.969-4.969A.9.9,0,1,0,11.469.263L6.5,5.231,1.532.263A.9.9,0,0,0,.263,1.532L5.231,6.5.263,11.469A.9.9,0,0,0,.263,12.738Z" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                                                        </clipPath>
                                                                                                    </defs>
                                                                                                    <g id="Group_15496" data-name="Group 15496" transform="translate(0.5 0.585)">
                                                                                                        <path id="Close-2" data-name="Close" d="M.263,12.738a.9.9,0,0,0,1.269,0L6.5,7.769l4.969,4.969a.9.9,0,0,0,1.269-1.269L7.769,6.5l4.969-4.969A.9.9,0,1,0,11.469.263L6.5,5.231,1.532.263A.9.9,0,0,0,.263,1.532L5.231,6.5.263,11.469A.9.9,0,0,0,.263,12.738Z" transform="translate(0 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                                                    </g>
                                                                                                </svg>
                                                                                            </div>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <div data-tooltip="View Details" data-position="top center" data-inverted="" className={"view-icon-container"} onClick={(e) => onViewFormData(e, serviceRequest.sbr.singleBuyerRequestID, serviceRequest.sbr.buyerID, serviceRequest.sbr.timezone)} >
                                                                                                <img src={detail_eye} className="view-icon" />
                                                                                            </div>
                                                                                            <div data-tooltip="Edit" data-position="top center" data-inverted="" className={`edit-icon-container ${editIconDisabled(serviceRequest) ? "disabled" : ""}`} onClick={editIconDisabled(serviceRequest) ? () => { } : (e) => onEditFormData(e, serviceRequest.sbr.singleBuyerRequestID, serviceRequest.sbr.serviceFormData)}  >
                                                                                                <img src={edit_pen} className="edit-icon" />
                                                                                            </div>
                                                                                            <div data-tooltip="Mark Serviced" data-position="left center" data-inverted="" className={`mark-service-icon-container ${markServedIconDisabled(serviceRequest) ? "disabled" : ""}`} onClick={markServedIconDisabled(serviceRequest) ? () => { } : (e) => onMarkAsServiced(e, serviceRequest.sbr.singleBuyerRequestID)} >
                                                                                                {/* <Icon className={"mark-service-icon"} name="thumbs up outline" size='large' ></Icon> */}
                                                                                                <img src={mark_serviced_icon} className="mark-service-icon" />
                                                                                            </div>
                                                                                        </>
                                                                                }

                                                                                {/* <div className="edit-icons">
                                                                                    <Button primary ref={updateIconRef}  {...
                                                                                        {
                                                                                            disabled: (_.isEmpty(newServiceForCurrentRequest) ? true : false)
                                                                                        }}
                                                                                        animated='vertical' onClick={onChangeServiceClick}>
                                                                                        <Button.Content hidden>Save</Button.Content>
                                                                                        <Button.Content visible>
                                                                                            <Icon name='check circle' />
                                                                                        </Button.Content>
                                                                                    </Button>
                                                                                    <Button
                                                                                        animated='vertical' onClick={onServiceEditCancel}>
                                                                                        <Button.Content hidden>Cancel</Button.Content>
                                                                                        <Button.Content visible>
                                                                                            <Icon name='delete' />
                                                                                        </Button.Content>
                                                                                    </Button>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                    </div>
                                            }
                                            {/* <Container fluid>
                                <Table>
                                    <Table.Header className="table-header">
                                        <Table.Row>
                                            <Table.HeaderCell>ID</Table.HeaderCell>
                                            <Table.HeaderCell>Service</Table.HeaderCell>
                                            <Table.HeaderCell>Expiring On</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body className="table-body">
                                            { !isEmpty(serviceRequestList) && serviceRequestList.map((serviceRequest) => {
                                                return <Table.Row key={`row_${serviceRequest.sbr.singleBuyerRequestID}`} className={`table-row ${selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? "selected" : "" : ""}`} >
                                                            <Table.Cell 
                                                            onClick={selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? () => {} : ()=> {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);} : () => {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);}}  >
                                                                <div>
                                                                    {serviceRequest.sbr.singleBuyerRequestID} 
                                                                </div>
                                                            </Table.Cell> */}


                                            {/* <Table.Cell>
                                                                <div>
                                                                    {serviceRequest.buyer.buyerName} {!_.isEmpty(serviceRequest.buyer.buyerCellPhone) ? `(${serviceRequest.buyer.buyerCellPhone})` : ''}
                                                                </div>
                                                            </Table.Cell> */}

                                            {/* <Table.Cell 
                                                            onClick={selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID || !serviceRequest.sbr.isAccepted ? () => {} : ()=> {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);} : () => {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);}} 
                                                            >
                                                            {!serviceRequest.sbr.isAccepted &&
                                                                <React.Fragment>
                                                                    <div className={(serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID )? 'service-title edit' : 'service-title'}
                                                                        style={{ pointerEvents: isInEditMode() ? 'none' : 'auto' }}
                                                                        onClick={(e) => onEditServiceClick(e, serviceRequest.sbr.singleBuyerRequestID, serviceRequest.service, serviceRequest.sbr.lat, serviceRequest.sbr.lon)}>
                                                                        {serviceRequest.service.name}
                                                                    </div>

                                                                </React.Fragment>
                                                            }
                                                            {serviceRequest.sbr.isAccepted && 
                                                                <div>{serviceRequest.service.name} </div>
                                                            }
                                                            {(serviceNameChangeState && serviceRequest.sbr.singleBuyerRequestID == currentRequestID) ?
                                                                <React.Fragment>

                                                                    <SearchServiceControl setSelectedService={setSelectedService} skipServiceID={serviceRequest.service.serviceID} />

                                                                    <div className="edit-icons">
                                                                        <Button primary ref={updateIconRef}  {...
                                                                            {
                                                                                disabled: (_.isEmpty(newServiceForCurrentRequest) ? true : false)
                                                                            }}
                                                                            animated='vertical' onClick={onChangeServiceClick}>
                                                                            <Button.Content hidden>Save</Button.Content>
                                                                            <Button.Content visible>
                                                                                <Icon name='check circle' />
                                                                            </Button.Content>
                                                                        </Button>
                                                                        <Button
                                                                            animated='vertical' onClick={onServiceEditCancel}>
                                                                            <Button.Content hidden>Cancel</Button.Content>
                                                                            <Button.Content visible>
                                                                                <Icon name='delete' />
                                                                            </Button.Content>
                                                                        </Button>

                                                                    </div>
                                                                </React.Fragment> : ""
                                                            }

                                                            </Table.Cell>
                                                            <Table.Cell  
                                                            onClick={selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID === serviceRequest.sbr.singleBuyerRequestID ? () => {} : ()=> {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);} : () => {setSelectedServiceRequest(serviceRequest); setEditMode('') ; setSideBarIsOpen(false);}} 
                                                            >
                                                            <div style={{display:"inline !important"}} className={moment(serviceRequest.sbr.expiry) < moment() ? 'expired expired-new': ''}>
                                                            {
                                                                <ExpiredColumn request={serviceRequest} />
                                                            }
                                                            </div> */}



                                            {/* {!selectedServiceRequest.sbr.isAccepted &&
                                                            <div style={{ margin: '0px 5px ', display:"inline" }}>
                                                                
                                                                <div className={"extend-icon-container"}>         
                                                                <img src={extend_icon} className="extend-icon" onClick={(e) => onExtendExpiryClick(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.service)} />                                      
                                                                </div>

                                                                <div className={"expire-icon-container"}>         
                                                                <img src={expiry_icon} className="expire-icon" onClick={(e) => onExpireRequest(e, selectedServiceRequest.sbr.singleBuyerRequestID)} />                                      
                                                                </div>

                                                            </div>
                                                            } */}



                                            {/* </Table.Cell>                                                         
                                                    </Table.Row>
                                            })}
                                    </Table.Body>
                                </Table>
                            </Container> */}
                                        </div>
                                    </>
                                    : ""}




                        </div>
                    </div>
                    {/* <div className="content-panel content-area">
                    <div className="mobile-header">
                        <div className="main-heading">
                            Service Requests
                        </div>
                    </div>
            </div> */}

                    <div className="content-panel content-area">
                        <Confirm open={showConfirm} className={`confirmation-popup confirm ${showServiceFormModal === true ? "edit-form-modal" : ""}`}
                            content={getConfirmationContent(true)/*confirmationMessage*/}
                            onCancel={onServiceUpdateCancel}
                            onConfirm={onServiceUpdateConfirm}
                        />
                        {requestUpdateErrorMessage.length > 0 && <GeneralError ref={errorMessageRef} message={requestUpdateErrorMessage} />}

                        {
                            selectedServiceRequest.sbr ?

                                <Grid relaxed='very' stackable className={"widget-grid"}>
                                    {
                                        expandState.expandMap == false ?
                                            <Grid.Column width={6} style={{ paddingRight: "0px" }} className={"left-widget-column"}>

                                                {
                                                    windowSize.width < 768 &&
                                                    <Container fluid className={"request-detail-container"}>
                                                        <Table>
                                                            <Table.Body className="table-body">
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Request
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {selectedServiceRequest.sbr.singleBuyerRequestID}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Buyer
                                                                    </Table.Cell>
                                                                    <Table.Cell>

                                                                        {
                                                                            isBuyerNumberEditState ?
                                                                                <div className={"buyer-number-edit-container-mobile"}>
                                                                                    <Formsy ref={formRef} onValidSubmit={() => { }}>
                                                                                        <DGTextbox name="cellnumber"
                                                                                            label="" placeholder="" required type="text"
                                                                                            maxLength={14}
                                                                                            tabIndex={2}
                                                                                            // icon={fieldPhoneIcon}
                                                                                            validations={{
                                                                                                isValidCellNumber: true
                                                                                            }}
                                                                                            validationErrors={{
                                                                                                isDefaultRequiredValue: 'This field is required',
                                                                                                isValidCellNumber: 'Invalid Cell Number'
                                                                                            }}
                                                                                            onChange={(e) => handlePhoneChange(e)}
                                                                                            onKeyDown={(e) => onPhoneKeyDown(e)}
                                                                                            value={buyerNewNumberState ? format(buyerNewNumberState) : ""}
                                                                                        />
                                                                                        <div className={`buyer-edit-icons-container`}>
                                                                                            <div data-tooltip="Save" data-position="top center" data-inverted="" className={`save-icon-container ${_.isEmpty(buyerNewNumberState) || buyerNewNumberState == format(buyerDetailsState.buyerCellPhone) || buyerNewNumberState.length != 14 ? "disabled" : ""}`} onClick={_.isEmpty(buyerNewNumberState) || buyerNewNumberState == format(buyerDetailsState.buyerCellPhone) || buyerNewNumberState.length != 14 ? () => { } : (e) => onBuyerNumberEditSaveClick()} >
                                                                                                <svg className="save-icon" xmlns="http://www.w3.org/2000/svg" width="22.137" height="15.309" viewBox="0 0 22.137 15.309">
                                                                                                    <path id="Path_29165" data-name="Path 29165" d="M735.7,189.278c1.225-.97,2.413-1.916,3.606-2.854q3.56-2.8,7.126-5.591c.538-.422,1.069-.853,1.614-1.266a1.553,1.553,0,0,1,1.314-.367,1.076,1.076,0,0,1,.772,1.562,2.625,2.625,0,0,1-.51.706q-6.171,6.174-12.355,12.335a2.132,2.132,0,0,1-3.1.011q-2.727-2.7-5.433-5.424a2.139,2.139,0,0,1-.048-2.961,2.115,2.115,0,0,1,2.974-.157c.882.811,1.712,1.68,2.562,2.525C734.711,188.285,735.2,188.777,735.7,189.278Z" transform="translate(-728.113 -179.168)" fill="#7ac943" />
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div data-tooltip="Cancel" data-position="top center" data-inverted="" className={`cancel-icon-container`} onClick={onBuyerNumberEditCancel} >
                                                                                                <svg className="cancel-icon" xmlns="http://www.w3.org/2000/svg" width="14.085" height="14.085" viewBox="0 0 14.085 14.085">
                                                                                                    <g id="Group_15496" data-name="Group 15496" transform="translate(0.5 0.585)">
                                                                                                        <path id="Close-2" data-name="Close" d="M.263,12.738a.9.9,0,0,0,1.269,0L6.5,7.769l4.969,4.969a.9.9,0,0,0,1.269-1.269L7.769,6.5l4.969-4.969A.9.9,0,1,0,11.469.263L6.5,5.231,1.532.263A.9.9,0,0,0,.263,1.532L5.231,6.5.263,11.469A.9.9,0,0,0,.263,12.738Z" transform="translate(0 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                                                    </g>
                                                                                                </svg>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Formsy>
                                                                                </div>
                                                                                :
                                                                                <div className={"heading-text buyer-number-display-container-mobile"}>
                                                                                    {((buyerCallingEnabled && selectedServiceRequest.sbr.assignedUserID == currentUser.userID) || callAnyoneEnabled) ?
                                                                                        <div className='buyer-calling' onClick={initiateBuyerCall}><Icon name='phone' className="seller-phone-icon"> </Icon></div>
                                                                                        :
                                                                                        <a href={`tel:${getFormattedBuyerPhoneNumber(buyerDetailsState)}`}> <Icon name='phone' className="seller-phone-icon"> </Icon></a>
                                                                                    }
                                                                                    
                                                                                    {buyerDetailsState.buyerName}
                                                                                    <span className={`buyer-number-display ${buyerNumberEditEnabled ? "" : " edit-disabled"}`} onClick={buyerNumberEditEnabled ? () => handleEditBuyerNumber() : () => { }}>
                                                                                        {!_.isEmpty(buyerDetailsState.buyerCellPhone) ? `(${buyerDetailsState.buyerCellPhone}) ` : ''}
                                                                                    </span>
                                                                                    <span data-tooltip={buyerPhoneNoCopyToolTipText} data-position="top center" data-inverted=""
                                                                                        onMouseLeave={() => setBuyerPhoneNoCopyToolTipText("Copy")}
                                                                                        onMouseEnter={() => setBuyerPhoneNoCopyToolTipText("Copy")}
                                                                                        onClick={() => copyBuyerNumber()}
                                                                                        className={"buyer-no-copy-icon"}>
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg" width="13.312" height="12.536" viewBox="0 0 13.312 12.536">
                                                                                            <g id="Group_16193" data-name="Group 16193" transform="translate(0.15 0.15)">
                                                                                                <g id="Group_16198" data-name="Group 16198" transform="translate(0 0)">
                                                                                                    <path id="Path_29436" data-name="Path 29436" d="M10.773,78.262H0V68.276H10.773Zm-.744-9.254H9.847q-4.465,0-8.93,0c-.145,0-.2.03-.2.188q.008,4.078,0,8.157c0,.054.005.107.008.164h9.294Z" transform="translate(0 -66.026)" stroke="#377DFF" fill="#377DFF" stroke-width="0.3" />
                                                                                                    <path id="Path_29437" data-name="Path 29437" d="M86.724.738H76.972V0H87.448V9.661h-.725Z" transform="translate(-74.436 0)" stroke="#377DFF" fill="#377DFF" stroke-width="0.3" />
                                                                                                </g>
                                                                                            </g>
                                                                                        </svg>
                                                                                    </span>
                                                                                </div>
                                                                        }

                                                                        {/* <a href={`tel:${getFormattedBuyerPhoneNumber(buyerDetailsState)}`}> <Icon name='phone' className="seller-phone-icon"> </Icon></a>   {buyerDetailsState.buyerName} {!_.isEmpty(buyerDetailsState.buyerCellPhone) ? `(${buyerDetailsState.buyerCellPhone})` : ''} */}

                                                                    </Table.Cell>
                                                                </Table.Row>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Initiated On
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {moment(selectedServiceRequest.sbr.initiated).format('MMM DD YYYY')}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Expiring On
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        <div style={{ display: "inline" }} className={moment(selectedServiceRequest.sbr.expiry) < moment() ? 'expired expired-new' : ''}>
                                                                            {
                                                                                // in case of mobile
                                                                                <ExpiredColumn request={selectedServiceRequest} />
                                                                            }
                                                                        </div>
                                                                        {!selectedServiceRequest.sbr.isAccepted &&
                                                                            <div style={{ margin: '0px 5px ', display: "inline" }}>
                                                                                <div className={"icon-container"} style={{ display: "inline" }}>
                                                                                    <img src={extend_icon} className="icon" onClick={(e) => onExtendExpiryClick(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.service)} />
                                                                                </div>

                                                                                <div className={"icon-container"} style={{ display: "inline" }}>
                                                                                    <img src={expiry_icon} className="icon" onClick={(e) => onExpireRequest(e, selectedServiceRequest.sbr.singleBuyerRequestID)} />
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Quick Info
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        {selectedServiceRequest.sbr.quickInfo}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                                <Table.Row>
                                                                    <Table.Cell>
                                                                        Quick Actions
                                                                    </Table.Cell>
                                                                    <Table.Cell>
                                                                        <div className={"icons-container"}>
                                                                            <div className={"view-icon-container"} onClick={(e) => onViewFormData(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.sbr.buyerID, selectedServiceRequest.sbr.timezone)} >
                                                                                <img src={detail_eye} className="view-icon" />
                                                                            </div>
                                                                            <div className={`edit-icon-container ${editIconDisabled(selectedServiceRequest) ? "disabled" : ""}`} onClick={editIconDisabled(selectedServiceRequest) ? () => { } : (e) => onEditFormData(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.sbr.serviceFormData)}  >
                                                                                <img src={edit_pen} className="edit-icon" />
                                                                            </div>
                                                                            <div className={`mark-service-icon-container ${markServedIconDisabled(selectedServiceRequest) ? "disabled" : ""}`} onClick={markServedIconDisabled(selectedServiceRequest) ? () => { } : (e) => onMarkAsServiced(e, selectedServiceRequest.sbr.singleBuyerRequestID)} >
                                                                                <Icon className={"mark-service-icon"} name="thumbs up outline" size='large' ></Icon>
                                                                                {/* <img src={} className="mark-service-icon" />   */}
                                                                            </div>
                                                                        </div>
                                                                        {/* <Menu.Item position={"right"} header className="menu-item-container view-edit-icon-container">
                                                                              
                                    </Menu.Item> */}
                                                                    </Table.Cell>
                                                                </Table.Row>
                                                            </Table.Body>
                                                        </Table>
                                                    </Container>
                                                }
                                                {(expandState.expandNotes || expandState.expandChat || expandState.expandCallHistory) ? "" :
                                                    <Container className={`left-container ${expandState.expandBidHistory ? "expend" : ""}`} fluid style={{height: '75px'}} >
                                                        <ServiceRequestBidHistory bidPlacementSearchEnabled={bidPlacementSearchEnabled} expandComponent={() => toogleExpandComponent("expandBidHistory")} isExpand={expandState.expandBidHistory} key={"BidHistory-" + keysState.ServiceRequestBidHistory} openModal={(e) => onShowBidHistory(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.service, selectedServiceRequest.sbr.discountPercent, selectedServiceRequest.sbr.discountAmount, selectedServiceRequest.sbr.isAccepted, selectedServiceRequest.sbr.timezone)} serviceid={selectedServiceRequest.service.serviceID} servicename={selectedServiceRequest.service.name} open={showBidHistoryModal} timezone={selectedServiceRequest.sbr.timezone} singleBuyerRequestID={selectedServiceRequest.sbr.singleBuyerRequestID} discount={getDiscount(selectedServiceRequest.sbr.discountPercent, selectedServiceRequest.sbr.discountAmount)} isRequestAccepted={selectedServiceRequest.sbr.isAccepted} />
                                                        
                                                    </Container>
                                                }
                                                {(expandState.expandNotes || expandState.expandChat || expandState.expandBidHistory) ? "" :
                                                    <Container className={`left-container ${expandState.expandCallHistory ? "expend" : ""}`} fluid style={{height: '272px'}}>
                                                        
                                                        <ServiceRequestCallHistory 
                                                        expandComponent={() => toogleExpandComponent("expandCallHistory")} 
                                                        isExpand={expandState.expandCallHistory} 
                                                        key={"CallHistory"}
                                                        singleBuyerRequestID={selectedServiceRequest.sbr.singleBuyerRequestID}
                                                        currentUser={currentUser} />
                                                    </Container>
                                                }
                                                {
                                                    (expandState.expandBidHistory || expandState.expandChat || expandState.expandCallHistory) ? "" :
                                                        <Container className={`left-container ${expandState.expandNotes ? "expend" : ""}`} fluid>
                                                            <ServiceRequestNotesNew addRequestNotesEnabled={addRequestNotesEnabled} expandComponent={() => toogleExpandComponent("expandNotes")} isExpand={expandState.expandNotes} key={"Notes-" + keysState.ServiceRequestNotes} showClose={false} openModal={(e) => onShowNotesModal(e, selectedServiceRequest.sbr.singleBuyerRequestID, selectedServiceRequest.service)} singleBuyerRequestID={selectedServiceRequest.sbr.singleBuyerRequestID} isRequestAccepted={serviceRequestIsAccepted} />
                                                        </Container>
                                                }

                                                {
                                                    (expandState.expandBidHistory || expandState.expandNotes || expandState.expandCallHistory) ? "" :
                                                        <Container className={`left-container ${expandState.expandChat ? "expend" : ""} large`} fluid>
                                                            <ChatContainerNew key={"chat-comp-key"+selectedServiceRequest.sbr.singleBuyerRequestID} buyer={buyerDetailsState} sbr={selectedServiceRequest.sbr} service={selectedServiceRequest.service} isSnippetsOpen={isSnippetsOpen} toggleSnippets={(isSnippetsOpen) => toggleSnippets(isSnippetsOpen)} expandComponent={() => toogleExpandComponent("expandChat")} isExpand={expandState.expandChat} showClose={false} onClose={onSMSClose} singleBuyerRequestID={selectedServiceRequest.sbr.singleBuyerRequestID} />
                                                        </Container>
                                                }

                                            </Grid.Column> : ""
                                    }
                                    <Grid.Column width={expandState.expandMap ? 16 : 10} className={"right-widget-column"}>
                                        <Container fluid className={"right-container"}>
                                            <ServiceRequestMapNew
                                                refreshBidHistoryData={refreshBidHistoryComponent}
                                                expandComponent={() => toogleExpandComponent("expandMap")}
                                                isExpand={expandState.expandMap}
                                                showClose={false}
                                                lat={selectedServiceRequest.sbr.lat}
                                                lon={selectedServiceRequest.sbr.lon}
                                                serviceID={selectedServiceRequest.service.serviceID}
                                                sbr={selectedServiceRequest.sbr}
                                                selectedServiceRequest={selectedServiceRequest}
                                                onClose={onMapClose}
                                                showProsLinkEnabled={showProsLinkEnabled}
                                                currentUser={currentUser} 
                                                buyer = {buyerDetailsState}
                                                startCall={startBuyerCall}
                                                onEndCall={endCall}
                                                onStartSellerCall={onStartSellerCall}
                                                
                                                />
                                        </Container>
                                    </Grid.Column>
                                </Grid>
                                : ""}
                        <CallScriptConatiner serviceID={selectedServiceRequest.service && selectedServiceRequest.service.serviceID} />
                    </div >


                    <DealDetailsModal
                        closeHandler={onRequestDetailsModalClose}
                        open={showDetailsModal}
                        maxImageCount={6}//this.props.deal.maxImageCount}
                        type=''
                        onBidAcceptance={(bid) => {
                            setShowBidAcceptanceConfirmationModal(true);
                            setSelectedBid(bid);
                        }}
                        singleBuyerRequestID={currentRequestID}
                        buyerID={currentRequestBuyerID}
                        bids={bids}
                        timezone={currentRequestTimezone} />

                    <ServiceRequestBidHistoryModal serviceid={serviceRequestCurrentService.serviceID} servicename={serviceRequestCurrentService.name} open={showBidHistoryModal} timezone={currentRequestTimezone} onClose={onShowBidHistoryClose} singleBuyerRequestID={currentRequestID} discount={currentRequestDiscount} isRequestAccepted={serviceRequestIsAccepted} />

                    <ServiceRequestNotesModal open={showNotesModal} onClose={onNotesModalClose} onNotesAdd={onNotesModalClose} singleBuyerRequestID={selectedServiceRequest.sbr ? selectedServiceRequest.sbr.singleBuyerRequestID : null} />

                    <ServiceFormModal open={showServiceFormModal} singleBuyerRequestID={currentRequestID} closeHandler={onRequestServiceFormModalClose} formData={serviceFormData} showApplyPromoCode={false} showImageUpload={false} onCancel={onFormDataEditCancel} onValidSubmit={onValidFormDataSubmit}></ServiceFormModal>

                    <Modal
                        className="bid-acceptance-confirm-modal confirm"
                        onClose={() => {
                            setShowBidAcceptanceConfirmationModal(false);
                            setSelectedBid({});
                        }}
                        open={showBidAcceptanceConfirmationModal}
                    >
                        <Modal.Header>Accept Bid</Modal.Header>
                        <Modal.Content>
                            <Formsy>
                                <Modal.Description>
                                    Do you want to accept {selectedBid.seller ? selectedBid.seller.name : ''}'s bid of ${selectedBid.sellerBid ? selectedBid.sellerBid.price.toFixed(2) : ''}?
                                </Modal.Description>
                                {selectedBid.sellerBid && bidAcceptAttemptIDs.includes(selectedBid.sellerBid.sellerBidHistoryID) && checkManagerAuthorization(featuresList.COMMISSION_PAYMENT_OVERRIDE, props.currentUser) ? <Checkbox name='paymentFailureOverrride' checked={paymentFailureOverrride} onChange={(e, data) => setPaymentFailureOverrride(data.checked)} label='Accept Bid independent of payment failure' /> : ''}
                            </Formsy>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={() => {
                                setShowBidAcceptanceConfirmationModal(false);
                                setSelectedBid({});
                            }}>Cancel</Button>
                            <Button onClick={confirmAcceptHandler} positive loading={acceptBidLoading} disabled={acceptBidLoading}>
                                Accept
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    <Modal
                        open={showErrorModal}
                        onClose={() => {
                            setAcceptBidError('')
                            setShowErrorModal(true);
                        }}
                    >
                        <Modal.Header className='service-request-error-header'>Error</Modal.Header>
                        <Modal.Content className='service-request-error-content'>
                            <Modal.Description>
                                {acceptBidError}
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className='service-request-error-action' onClick={() => setShowErrorModal(false)}>OK</Button>
                        </Modal.Actions>
                    </Modal>



                    <Modal className='price-confirmation-modal'
                        open={showConfirmPriceModal}
                        onClose={() => {
                            setShowConfirmPriceModal(false)
                        }}
                    >
                        <Modal.Header>Confirm Pricing</Modal.Header>
                        <Modal.Content>
                            <Formsy onValidSubmit={onPriceConfirmationSubmit}>
                                <div className='input-controls'>
                                    <DGTextbox name="confirm-price" label="Price" placeholder=""
                                    required
                                    validations={{
                                        postiveNumber: true,
                                        isInt: true
                                    }}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Price is required',
                                        postiveNumber: 'Invalid value',
                                        isInt: 'Invalid value'
                                    }}
                                    onChange={onConfirmationPriceChange}
                                    ></DGTextbox>
                                </div>

                                <div className='actions'>
                                    <Button type="submit" primary >Save</Button>
                                    <Button onClick={() => {setShowConfirmPriceModal(false)}}>Cancel</Button>
                                    <Button type="button" negative onClick={resetConfirmationPrice}>Reset</Button>
                                </div>

                            </Formsy>
                            
                        </Modal.Content>
                       
                        
                    </Modal>
                </div>

            </div>

        </>)
}

function mapStateToProps({ auth, reducer, appView, locationDetails, searchForm }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component

    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        locationEnabled: locationDetails.locationEnabled,
        lat: locationDetails.lat,
        lon: locationDetails.lon,
        showSearchFormInHeader: searchForm.showSearchBarInHeader,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState,
        setSearchFormVisibilityInHeader,
        setPageType,
        setShowSidebar
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestListContainerNew);



//export default ServiceRequestListContainerNew
